var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-main" }, [
    _c(
      "div",
      { staticStyle: { display: "flex" } },
      [
        _c("i", {
          staticClass: "fa-regular fa-file-lines",
          staticStyle: { "margin-right": "8px", "font-size": "18px" }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "c-uploader-progress-bg",
          class:
            _vm.file.__failed || _vm.file.__failedNoPassword
              ? "c-uploader-progress-bg-negative"
              : "",
          style: _vm.fileProgressPercent
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "c-uploader-file-name",
            class:
              _vm.file.__failed || _vm.file.__failedNoPassword
                ? "c-uploader-file-name-negative"
                : ""
          },
          [_vm._v("\n      " + _vm._s(this.file.name) + "\n    ")]
        ),
        _vm._v(" "),
        this.file.__password
          ? _c("v-input", {
              ref: this.file.id + "password",
              class: [
                !_vm.file.__password ? "c-uploader-spacer" : "",
                _vm.file.__password &&
                _vm.file.__failedNoPassword &&
                !_vm.file.password
                  ? "c-uploader-input invalid"
                  : "",
                _vm.file.__password ? "c-uploader-input" : "",
                _vm.file.__password &&
                !_vm.file.__failedNoPassword &&
                _vm.file.password
                  ? "c-uploader-input valid disabled"
                  : ""
              ],
              attrs: {
                type: "password",
                name: this.file.id + "password",
                value: this.file.password,
                placeholder: "Enter password"
              }
            })
          : _c("div", {
              ref: this.file.id + "password",
              class: [
                !_vm.file.__password ? "c-uploader-spacer" : "",
                _vm.file.__password &&
                _vm.file.__failedNoPassword &&
                !_vm.file.password
                  ? "c-uploader-input invalid"
                  : "",
                _vm.file.__password ? "c-uploader-input" : "",
                _vm.file.__password &&
                !_vm.file.__failedNoPassword &&
                _vm.file.password
                  ? "c-uploader-input valid disabled"
                  : ""
              ],
              attrs: {
                type: "password",
                name: this.file.id + "password",
                value: this.file.password,
                placeholder: "Enter password"
              }
            }),
        _vm._v(" "),
        _vm.file.__password && _vm.file.__failedNoPassword && !_vm.file.password
          ? _c("div", { staticClass: "c-uploader-button-invalid mr-10" }, [
              _vm._v(
                "\n      Could not validate the entered password. Please try again.\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.file.__password && !_vm.file.__failedNoPassword && _vm.file.password
          ? _c(
              "div",
              { staticClass: "c-uploader-button-valid mr-10" },
              [
                _c("div", [
                  _vm._v(
                    "Password has been validated. Field has been temporary locked."
                  )
                ]),
                _vm._v(" "),
                _c("v-icon", { attrs: { size: "20", color: "#8BB84D" } }, [
                  _vm._v(" mdi-checkbox-marked-circle ")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.file.__password && !_vm.file.password
          ? _c(
              "div",
              {
                staticClass: "c-uploader-button-save mr-10",
                on: { click: this.onSavePassword }
              },
              [_vm._v("\n      Unlock\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.file.__failed
          ? _c(
              "div",
              {
                staticClass: "c-uploader-button-restart mr-10",
                on: { click: this.onRestart }
              },
              [
                _c("v-icon", { attrs: { size: "20", color: "#8BB84D" } }, [
                  _vm._v(" mdi-arrow-u-left-top")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.file.__progress !== 0
          ? _c("div", { staticClass: "c-uploader-progress-text mr-10" }, [
              _vm._v("\n      " + _vm._s(_vm.file.__progress + "%") + "\n    ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.file.__doneUploading
          ? _c(
              "div",
              { staticClass: "c-uploader-button-remove cursor-pointer" },
              [_c("v-icon", { attrs: { color: "green" } })],
              1
            )
          : _c("i", {
              staticClass: "fa-solid fa-xmark",
              staticStyle: {
                "font-size": "18px",
                color: "#161616",
                cursor: "pointer"
              },
              on: { click: this.onRemove }
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }